import React from 'react';
import classnames from 'classnames';
import Timestamp from '../../../../Timestamp';
import { getThumbGlobalClassNames } from '../../helpers';
var StatusThumbHtmlView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation)) },
        React.createElement("div", { className: "daeditor-freeform-body" },
            React.createElement("div", { className: "daeditor-freeform-date" },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime })),
            React.createElement("div", { className: "daeditor-freeform-text" }, deviation.textContent && deviation.textContent.excerpt))));
};
StatusThumbHtmlView.displayName = 'StatusThumbHtmlView';
export default StatusThumbHtmlView;
//# sourceMappingURL=StatusHtml.js.map